/** Bump the version suffix when the persisted shape changes incompatibly. */
export const STORAGE_KEY = 'sqlprep.v4';
